import { CARD_ZOOM_LEVELS } from "@/lib/const";
import { localStorageManager } from "@/services/localStorage";
import { LOCAL_STORAGE_BASE_KEYS } from "@/types/v2";

export type ZoomTier = "normal" | "emphasize" | "expand";

export const getZoomTier = (zoom: number): ZoomTier => {
  if (zoom >= 1.2) return "expand";
  if (zoom <= 0.8) return "emphasize";
  return "normal";
};

export const getActiveZoomIndex = (zoom: number): number => {
  let closestIndex = 0;
  let smallestDiff = Infinity;

  CARD_ZOOM_LEVELS.forEach((level, index) => {
    const diff = Math.abs(level - zoom);
    if (diff < smallestDiff) {
      smallestDiff = diff;
      closestIndex = index;
    }
  });

  return closestIndex;
};

export const getAdjacentZoomLevel = (
  zoom: number,
  direction: "in" | "out"
): number => {
  const activeIndex = getActiveZoomIndex(zoom);
  const nextIndex =
    direction === "in"
      ? Math.min(activeIndex + 1, CARD_ZOOM_LEVELS.length - 1)
      : Math.max(activeIndex - 1, 0);

  return CARD_ZOOM_LEVELS[nextIndex];
};

const ZOOM_BAR_MIN_HEIGHT = 8;
// Matches the h-6 (24px) +/- stepper buttons — the bar ramp must never grow
// taller than them, however many levels CARD_ZOOM_LEVELS ends up with.
const ZOOM_BAR_MAX_HEIGHT = 24;

export const getZoomBarHeight = (
  index: number,
  totalLevels: number
): number => {
  if (totalLevels <= 1) return ZOOM_BAR_MIN_HEIGHT;
  const step = (ZOOM_BAR_MAX_HEIGHT - ZOOM_BAR_MIN_HEIGHT) / (totalLevels - 1);
  return Math.round(ZOOM_BAR_MIN_HEIGHT + index * step);
};

export const getInitialCardZoom = (): number => {
  const stored = parseFloat(
    localStorageManager.getItem(LOCAL_STORAGE_BASE_KEYS.DASHBOARD_CARD_ZOOM) ??
      ""
  );
  if (Number.isNaN(stored)) return 1.0;
  return CARD_ZOOM_LEVELS[getActiveZoomIndex(stored)];
};

export const persistCardZoom = (zoom: number): void => {
  localStorageManager.setItem(
    LOCAL_STORAGE_BASE_KEYS.DASHBOARD_CARD_ZOOM,
    zoom
  );
};
